<template>
	<div class="adminMain">
		<!-- Tips -->
		<div class="tip">
			<div class="text-note">
				{{ siteConfigTips && siteConfigTips.tips_user_dashboard ? siteConfigTips.tips_user_dashboard: '--' }}
			</div>
			<div class="modify-note" @click="modalTip = true">
				<EditIcon />
				{{ $t('adminDashboard.controlPanel.modify') }}
			</div>
		</div>
		<!-- DESKTOP -->
		<!-- Main links -->
		<div v-if="!isMobile" class="card-dashboard">
			<div
				id="adminListing"
				@click="goToPage('admin-manage-listing')"
				class="card-item"
			>
				<div class="dashboard-title-card">
					{{ $t('adminDashboard.controlPanel.alllisting') }}
				</div>
				<div class="amount">
					{{ dataAdminDashboard ? dataAdminDashboard.all_listing : 0 }}
				</div>
				<div class="icon-card">
					<LightListIcon />
				</div>
			</div>
			<div
				id="adminApproveListing"
				@click="goToPage('admin-approve-listing')"
				class="card-item"
			>
				<div class="dashboard-title-card">
					{{ $t('adminDashboard.controlPanel.listing') }}
					<br />
					{{ $t('adminDashboard.controlPanel.toPreview') }}
				</div>
				<div class="amount">
					{{
						dataAdminDashboard
							? dataAdminDashboard.listing_waiting_for_approve
							: 0
					}}
				</div>
				<div class="icon-card">
					<LightClockIcon />
				</div>
			</div>
			<div
				id="adminMessage"
				@click="goToPage('admin-message')"
				class="card-item"
			>
				<div class="dashboard-title-card">
					{{ $t('adminDashboard.controlPanel.message') }}
					<br />
					{{ $t('adminDashboard.controlPanel.fromUser') }}
				</div>
				<div class="amount">
					{{ unreadMessages ? unreadMessages : 0 }}
				</div>
				<div class="icon-card">
					<LightMessageIcon />
				</div>
			</div>
			<div
				id="adminMemberAccount"
				@click="goToPage('admin-manage-users')"
				class="card-item"
			>
				<div class="dashboard-title-card">
					{{ $t('adminDashboard.controlPanel.memberAccount') }}
					<br />
					{{ $t('adminDashboard.controlPanel.all') }}
				</div>
				<div class="amount">
					{{ dataAdminDashboard ? dataAdminDashboard.all_member : 0 }}
				</div>
				<div class="icon-card icon-user">
					<LightUserIcon />
				</div>
			</div>
			<div class="card-item" @click="goToPage('admin-manage-users')">
				<div class="dashboard-title-card">
					{{ $t('adminDashboard.controlPanel.newMembers') }}
					<br />
					{{ $t('adminDashboard.controlPanel.today') }}
				</div>
				<div class="amount">
					{{ dataAdminDashboard ? dataAdminDashboard.member_today : 0 }}
				</div>
				<div class="icon-card">
					<LightUserPlusIcon />
				</div>
			</div>
			<div class="card-item">
				<div class="dashboard-title-card">
					xxxx
				</div>
				<div class="amount">0</div>
			</div>
		</div>
		<!-- MOBILE -->
		<div v-else class="user-main-mobile">
			<div class="wrap-navigate-mobile">
				<div class="navigate-item">
					<div
						@click="$router.push($i18nRoute({ name: '' }))"
						class="text-center"
					>
						<HomeOutlineIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.mobile.home') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('admin-profile')" class="text-center">
						<LightUserIcon />
						<div class="text">
							{{ $t('userDashboard.navigation.mobile.profile') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('admin-manage-listing')" class="text-center">
						<LightListIcon />
						<div class="text">
							{{ $t('adminDashboard.controlPanel.listing') }}
						</div>
					</div>
				</div>
				<div class="navigate-item">
					<div @click="goToPage('admin-approve-listing')" class="text-center">
						<CheckSquareIcon />
						<div class="text">
							{{ $t('adminDashboard.controlPanel.listing') }}
							<br />
							{{ $t('adminDashboard.controlPanel.toPreview') }}
						</div>
					</div>
				</div>
			</div>
			<div class="logout" @click="userLogout">
				<LogoutIcon />
				{{ $t('userDashboard.navigation.logout') }}
			</div>
		</div>
		<!-- MODAL -->
		<b-modal
			id="modal-tip"
			modal-class="modal-tip"
			centered
			hide-footer
			:title="$t('adminDashboard.controlPanel.modalTip.title')"
			v-model="modalTip"
		>
			<b-container fluid>
				<b-row class="mb-1 text-center">
					<b-form-textarea
						id="reasons-input"
						rows="4"
						no-resize
						v-model="tip.value"
					></b-form-textarea>
					<b-col cols="12" class="mt-3">
						<b-button class="btn-send" id="updateTip" @click="updateTip">{{
							$t('adminDashboard.controlPanel.modalTip.btnUpdate')
						}}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';

// Icons
import LightListIcon from '@/components/icons/IconLightList';
import LightClockIcon from '@/components/icons/IconLightClock';
import LightMessageIcon from '@/components/icons/IconLightMessage';
//import PencilOutlinedIcon from 'vue-material-design-icons/PencilOutline.vue';
import EditIcon from '@/components/icons/IconEdit/index';
import LightUserIcon from '@/components/icons/IconUser/index';
import LightUserPlusIcon from '@/components/icons/IconLightUserPlus/index';
import HomeOutlineIcon from '@/components/icons/IconHomeOutline';
import CheckSquareIcon from '@/components/icons/IconCheckSquare/index';
import LogoutIcon from '@/components/icons/IconLogout/index';

export default {
	components: {
		LightListIcon,
		LightClockIcon,
		LightMessageIcon,
		LightUserIcon,
		LightUserPlusIcon,
		EditIcon,
		HomeOutlineIcon,
		CheckSquareIcon,
		LogoutIcon
		//PencilOutlinedIcon
	},
	data() {
		return {
			modalTip: false,
			tip: {
				value: ''
			}
		};
	},
	mounted() {
		this.GET_SITE_TIPS();
	},
	watch: {
		modalTip: function(val) {
			if (val && this.siteConfigTips && this.siteConfigTips.tips_user_dashboard) {
				this.tip = Object.assign(this.tip, this.siteConfigTips.tips_user_dashboard);
			}
		}
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapGetters('AdminDashBoardController', ['dataAdminDashboard']),
		...mapState('SiteConfigController', ['siteConfigTips']),
		...mapGetters('ChatController', ['unreadMessages'])
	},
	methods: {
		...mapActions('AdminDashBoardController', ['GET_DATA_ADMIN_DASHBOARD']),
		...mapActions('SiteConfigController', [
			'GET_SITE_TIPS',
			'UPDATE_SITE_TIPS'
		]),
		updateTip() {
			this.UPDATE_SITE_TIPS({
				tips_admin_dashboard: this.tip.value,
				tips_user_dashboard: this.tip.value
			})
				.then(result => {
					this.modalTip = false;
					this.$bvToast.toast(
						this.$t('adminDashboard.controlPanel.modalTip.toast.content'),
						{
							title: this.$t(
								'adminDashboard.controlPanel.modalTip.toast.title'
							),
							variant: 'success',
							solid: true
						}
					);
				})
				.catch(err => {
					this.modalTip = false;
				});
		},
		fetchDataDashBoard() {
			this.GET_DATA_ADMIN_DASHBOARD();
		},

		goToPage(page) {
			this.$router.push(this.$i18nRoute({ name: page }));
		},

		userLogout() {
			this.$root.signOut();
		}
	},

	created() {
		this.fetchDataDashBoard();
	}
};
</script>

<style lang="scss">
@import 'adminMain.scss';
</style>
